import { getAdminInvoicingBackfillsListInfiniteQueryOptions, getNextPageParam } from "@sidegigllc/api/client";
import type { WarmableQuery } from "routing/warmQueries";

/** The endpoint's `max_page_size`. */
const PAGE_SIZE = 50;

export const backfillsQuery = () =>
  getAdminInvoicingBackfillsListInfiniteQueryOptions({ page_size: PAGE_SIZE }, { query: { getNextPageParam } });

export const queries = (): Array<WarmableQuery> => [backfillsQuery()];
